/* ============================================================================
   Remodius — Mega menu interactions
   ----------------------------------------------------------------------------
   Vanilla JS, geen dependencies. Werkt naast Impact's bestaande header.js.
   Idempotent — kan veilig herhaald worden uitgevoerd na Shopify section
   reloads (theme-editor edits dispatchen 'shopify:section:load').
============================================================================ */
(function () {
  'use strict';

  /* ---------------- helpers ---------------- */
  var $  = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------------- 1. Desktop mega menu ---------------- */
  function initMegaMenu(header) {
    var triggers = $$('[data-rem-mega-trigger]', header);
    var panels   = $$('[data-rem-mega-panel]', header);
    if (!triggers.length || !panels.length) return;

    var closeTimer = null;
    var activeHandle = null;

    function openPanel(handle) {
      clearTimeout(closeTimer);
      activeHandle = handle;
      triggers.forEach(function (t) {
        t.setAttribute('aria-expanded', t.dataset.remMegaTrigger === handle ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        p.hidden = p.dataset.remMegaPanel !== handle;
      });
    }

    function closeAll() {
      activeHandle = null;
      triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      panels.forEach(function (p) { p.hidden = true; });
    }

    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(closeAll, 120);
    }

    triggers.forEach(function (t) {
      t.addEventListener('mouseenter', function () { openPanel(t.dataset.remMegaTrigger); });
      t.addEventListener('focus',      function () { openPanel(t.dataset.remMegaTrigger); });

      // klik = open paneel zonder direct te navigeren (handig voor touch)
      t.addEventListener('click', function (e) {
        if (activeHandle !== t.dataset.remMegaTrigger) {
          e.preventDefault();
          openPanel(t.dataset.remMegaTrigger);
        }
      });
    });

    panels.forEach(function (p) {
      p.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
      p.addEventListener('mouseleave', scheduleClose);
    });

    $$('[data-rem-nav]', header).forEach(function (nav) {
      nav.addEventListener('mouseleave', scheduleClose);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && activeHandle) closeAll();
    });
  }

  /* ---------------- 2. Search dropdown ---------------- */
  function initSearch(header) {
    var toggle = $('[data-rem-search-toggle]', header);
    var panel  = $('[data-rem-search-panel]', header);
    if (!toggle || !panel) return;

    toggle.addEventListener('click', function () {
      var willOpen = panel.hidden;
      panel.hidden = !willOpen;
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      if (willOpen) {
        var input = $('input', panel);
        if (input) input.focus();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) {
        panel.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    });
  }

  /* ---------------- 3. Mobile drawer (push-nav) ---------------- */
  function initDrawer() {
    var drawer = $('#rem-mobile-drawer');
    if (!drawer) return;

    var toggles  = $$('[data-rem-drawer-toggle]');
    var closers  = $$('[data-rem-drawer-close]', drawer);
    var stage    = $('[data-rem-drawer-stage-inner]', drawer);
    var opens    = $$('[data-rem-drawer-open]', drawer);
    var backs    = $$('[data-rem-drawer-back]', drawer);
    var pages    = $$('[data-rem-drawer-page]', drawer);

    function showPage(handle) {
      pages.forEach(function (p) {
        p.hidden = p.dataset.remDrawerPage !== handle;
      });
      stage.dataset.remDrawerLevel = handle === 'root' ? '0' : '1';
    }

    function open() {
      drawer.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
      showPage('root');
      var f = drawer.querySelector('button, [href], input');
      if (f) f.focus();
    }
    function close() {
      drawer.hidden = true;
      document.documentElement.style.overflow = '';
      toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    }

    toggles.forEach(function (t) { t.addEventListener('click', open); });
    closers.forEach(function (c) { c.addEventListener('click', close); });

    opens.forEach(function (b) {
      b.addEventListener('click', function () {
        showPage(b.dataset.remDrawerOpen);
      });
    });
    backs.forEach(function (b) {
      b.addEventListener('click', function () { showPage('root'); });
    });

    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (stage && stage.dataset.remDrawerLevel === '1') showPage('root');
      else close();
    });
  }

  /* ---------------- 4. Cart counter (cart:updated event) ---------------- */
  function initCartListener() {
    document.addEventListener('cart:updated', function (e) {
      var c = (e.detail && e.detail.cart && e.detail.cart.item_count) || 0;
      $$('[data-cart-count]').forEach(function (n) { n.textContent = c; });
    });
  }

  /* ---------------- bootstrap ---------------- */
  function init() {
    var header = $('[data-rem-header]');
    if (!header) return;
    initMegaMenu(header);
    initSearch(header);
    initDrawer();
    initCartListener();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme-editor live reload
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.matches('.shopify-section--header, [class*="header"]')) init();
  });
})();
